interface IProps {
  data: number[];
  labels: string[];
  colors?: string[];
  title?: string;
  yLabel?: string;
  xLabel?: string;
  onImageUpdate?: (image: { url: string; name: string }) => void;
}

export default ({ yLabel, xLabel }: IProps): Chart.ChartConfiguration => ({
  type: 'bar',
  data: {
    labels: [],
    datasets: [
      {
        // barThickness: 65,
        categoryPercentage: 0.8,
        barPercentage: 0.8,
        data: [],
      },
    ],
  },
  options: {
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return tooltipItem.value
            ? parseFloat(tooltipItem.value).toLocaleString()
            : '';
        },
      },
    },
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1.5,
    scales: {
      yAxes: [
        {
          gridLines: {
            display: true,
            drawBorder: true,
            drawOnChartArea: false,
          },
          ticks: {
            display: false,
            beginAtZero: true,
            padding: 100,
          },
          scaleLabel: {
            display: yLabel !== undefined,
            labelString: yLabel,
            fontColor: '#000',
            padding: 0,
            fontSize: isSmallWidth() ? 11 : 14,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: true,
            drawBorder: true,
            drawOnChartArea: false,
          },
          ticks: {
            beginAtZero: true,
            callback: (value) => value.toLocaleString(),
          },
          scaleLabel: {
            display: xLabel !== undefined,
            labelString: xLabel,
            fontColor: '#000',
            padding: 0,
            fontSize: isSmallWidth() ? 11 : 14,
          },
        },
      ],
    },
    title: {
      display: false,
      fontSize: 18,
    },
    animation: {
      onComplete: () => {
        // setImage(((this as unknown) as Chart).toBase64Image());
      },
    },
  },
});

function isSmallWidth() {
  return window.innerWidth < 600;
}
